import { type Instructor } from "../../shared/types/instructor"
import React from "react"
import { ActionIcon, Badge, Group, Stack, Text, Tooltip, createStyles, rem } from "@mantine/core"
import { Image } from "../../shared/ui/Image"
import { API_URL } from "../../shared/config"
import { InstructorDeleteModal, InstructorPublishedModal } from "../../features/instructor"
import { Link } from "react-router-dom"
import { PATHS } from "../../shared/lib/paths"
import { IconPencil } from "@tabler/icons-react"
import { Draggable } from "react-beautiful-dnd"
import { IconGripVertical } from "@tabler/icons-react"
import { observer } from "mobx-react-lite"
import { InstructorStore } from "../../app/store"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  item: {
    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
  },

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  dragHandle: {
    ...theme.fn.focusStyles(),
    width: rem(40),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[6],
  },

  dragDisabled: {
    opacity: 0.3,
    pointerEvents: "none",
    userSelect: "none",
  },
}))

// ----------------------------------------------------------------------

export const InstructorTableRow = observer(function InstructorTableRow(instructor: Instructor) {
  const { classes, cx } = useStyles()
  const { avatar, name, _id, position, published, order } = instructor

  return (
    <Draggable isDragDisabled={InstructorStore.orderLoading} index={order} draggableId={_id}>
      {(provided) => (
        <tr className={classes.item} ref={provided.innerRef} {...provided.draggableProps}>
          <td>
            <div
              className={cx(classes.dragHandle, { [classes.dragDisabled]: InstructorStore.orderLoading })} {...provided.dragHandleProps}>
              <IconGripVertical size="1.05rem" stroke={1.5}/>
            </div>
          </td>
          <td
            style={{
              width: provided.draggableProps.style !== undefined && "width" in provided.draggableProps.style
                ? (provided.draggableProps.style["width"] - 40 - 150 - 220)
                : "unset",
            }}>
            <Group spacing="sm" align="flex-start" noWrap>
              <Image
                src={`${API_URL}/media/${avatar}`}
                ratio="1/1"
                sx={{ maxWidth: 64, borderRadius: "50%" }}
              />
              <Stack spacing={6}>
                <Text fz="xl" fw={600}>
                  {name}
                </Text>
                <Text fz="sm">{position}</Text>
              </Stack>
            </Group>
          </td>
          <td style={{ width: rem(150) }}>
            <Badge color={published ? "green" : "red"} fullWidth>
              {published ? "Да" : "Нет"}
            </Badge>
          </td>
          <td style={{ width: rem(220) }}>
            <Group position="right" noWrap>
              <InstructorPublishedModal {...instructor} />
              <Tooltip label="Редактировать">
                <ActionIcon
                  radius="xl"
                  size="xl"
                  component={Link}
                  to={PATHS.DASHBOARD.INSTRUCTORS.EDIT(_id)}
                >
                  <IconPencil stroke={1.5}/>
                </ActionIcon>
              </Tooltip>
              <InstructorDeleteModal {...instructor} />
            </Group>
          </td>
        </tr>
      )}
    </Draggable>
  )
})
